<template>
	<div class="container">
		<div class="circle-container">
			<div class="outer-circle">
				<div class="inner-circle"><img src="../assets/images/youtube_logo.png" alt="logo"></div>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
		<div class="normal" v-if="!state.signUp">
			<form @submit.prevent="validate" autocomplete="off">
				<div class="input">
					<input class="login" placeholder="username" name="username" v-model="username">
					<transition name="slide">
						<div v-if="invalidUser" class="error-container"><p class="error-message">invalid user.</p></div>
					</transition>
				</div>
				<div class="input">
					<input class="login" v-bind:class="{ invalid: invalidPassword }" type="password" placeholder="password" name="password" v-model="password">
					<transition name="slide">
						<div v-if="invalidPassword" class="error-container"><p class="error-message">invalid password. try again.</p></div>
					</transition>
				</div>
				<div class="button-container">
					<div>
						<input class="submit-button" type="submit" value="login" />
					</div>
					<div>
						<input class="guest-button" type="button" value="guest" @click="guestLogin" />
					</div>
				</div>
			</form>
			<div class="sign-up-container">
				<input class="sign-up" type="button" value="sign up" @click="signUp" />
			</div>
		</div>
		<div class="alternate" v-else>
			<form @submit.prevent="submitSignUp" autocomplete="off">
				<div class="input">
					<input title="User" class="login" v-bind:class="{ invalid: invalidUser }" placeholder="username" name="username" v-model="username" required oninvalid="this.setCustomValidity('Please enter valid username')" oninput="setCustomValidity('')">
					<transition name="slide">
						<div v-if="invalidUser" class="error-container"><p class="error-message">user already taken.</p></div>
					</transition>
				</div>
				<div class="input">
					<input title="Email" class="login" v-bind:class="{ invalid: invalidEmail }" type="email" placeholder="email" name="email" v-model="email" required oninvalid="this.setCustomValidity('Please enter valid username')" oninput="setCustomValidity('')">
					<transition name="slide">
						<div v-if="invalidEmail" class="error-container"><p class="error-message">invalid email.</p></div>
					</transition>
				</div>
				<div class="input">
					<input title="password" class="login" v-bind:class="{ invalid: invalidNewPassword }" type="password" placeholder="password" name="password" v-model="newPassword">
					<transition name="slide">
						<div v-if="invalidNewPassword" class="error-container"><p class="error-message">invalid password. try again.</p></div>
					</transition>
				</div>
				<div class="input">
					<input title="confirm password" class="login" v-bind:class="{ invalid: invalidConfirmedPassword }" type="password" placeholder="confirm password" name="password" v-model="confirmedPassword">
					<transition name="slide">
						<div v-if="invalidConfirmedPassword" class="error-container"><p class="error-message">passwords do not match.</p></div>
					</transition>
				</div>
				<div class="button-container">
					<div>
						<input class="sign-up" type="submit" value="sign up" />
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { computed, reactive } from 'vue'
import userService from '../services/UserDataService'

export default {
	name: 'Splash',
	setup() {
		const router = useRouter();
		const store = useStore();
		const login = () => {
			store.dispatch('setLoggedIn', true)
			router.push('/home');
		}
		const invalidPassword = computed(() => state.invalidPassword);
		const invalidUser = computed(() => state.invalidUser);
		const invalidEmail = computed(() => state.invalidEmail);
		const invalidNewPassword = computed(() => state.invalidNewPassword);
		const invalidConfirmedPassword = computed(() => state.invalidConfirmedPassword);

		const username = null
		const password = null
		const email = null
		const newPassword = null
		const confirmedPassword = null

		const state = reactive({
			invalidUser: false,
			invalidPassword: false,
			signUp: false,
			invalidEmail: false,
			invalidNewPassword: false,
			invalidConfirmedPassword: false
		})

		function validate(e) {
			console.log(this.username)
			state.invalidUser = false;
			state.invalidPassword = false;
			console.log(this.password)
			console.log('Calling user api')
			userService.getUser(this.username).then(res => {
				console.log(res.data)
				// User not found
				if (!res.data.Items.length) {
					state.invalidUser = true;
					this.username = '';
					this.password = '';
					console.log('User not found')
					return
				} else if (res.data.Items[0].password != this.password) { // Password incorrect
					state.invalidPassword = true;
					this.password = '';
					console.log('Password incorrect')
					return
				}
				// Admin
				let admin = false;
				if (this.username == 'admin') {
					store.dispatch('setAdmin', true);
					admin = true;
				}
				const userInfo = {
					username: this.username,
					password: this.password,
					admin
				};
				store.dispatch('setUserInfo', userInfo)
				login()
			}).catch(() => state.invalidUser = true);
			console.log(e)
			e.target.reset()
		}

		function guestLogin() {
			const userInfo = {
				username: 'guest',
				password: '',
				admin: false
			}
			store.dispatch('setUserInfo', userInfo);
			login()
		}

		function signUp() {
			state.signUp = true;
			state.invalidUser = false;
			state.invalidPassword = false;
		}

		async function submitSignUp(e) {
			state.invalidUser = false;
			state.invalidConfirmedPassword = false;
			await userService.getUser(this.username).then((res) => {
				console.log(res.data)
				if (res.data.Items.length) {
					state.invalidUser = true;
					console.log('user already exists')
					this.username = ''
				}
			}).catch()
			if (this.newPassword != this.confirmedPassword) {
				console.log('passwords do not match')
				state.invalidConfirmedPassword = true
				this.newPassword = ''
				this.confirmedPassword = ''
				return
			}
			const userInfo = {
				username: this.username,
				password: this.newPassword,
				email: this.email
			}
			await userService.createUser(userInfo).then(res => {
				console.log(res)
				const info = {
					username: this.username,
					password: this.newPassword,
					admin: false
				}
				store.dispatch('setUserInfo', info)
				login()
			}).catch(err => console.log(err))
			e.target.reset()
		}

		return {
			validate,
			username, 
			password,
			email,
			newPassword,
			confirmedPassword,
			state,
			invalidPassword,
			invalidUser,
			invalidEmail,
			invalidNewPassword,
			invalidConfirmedPassword,
			signUp,
			guestLogin,
			submitSignUp
		}
	}
}
</script>

<style scoped>
.error-container {
	display: inline;
	position: absolute;
	margin: 5pt 10pt;
}

.error-container p {
	padding: 0;
	margin: 0;
}

.slide-enter-active {
	transition: all 1s ease-out;
	/* animation: ease-out 5s; */
}

.slide-leave-active {
	transition: all 1s ease-out;
	/* animation: ease-in 5s; */
}

.slide-enter-from,
.slide-leave-to {
	transform: translateX(-100pt);
	opacity: 0;
	z-index: 0;
}

.container {
    background-color:black;
    position:fixed;
    width:100%;
    height:100%;
    top:0px;
	left:0px;
	display: flex;
	flex-direction: column;
}

form {
	position: relative;
	top: 75vh;
	/* bottom: 20rem; */
}

.sign-up-container {
	position: relative;
	top: 75vh;
	/* bottom: 20rem; */
}

.button-container, .sign-up-container {
	display: flex;
	justify-content: center;
}

.submit-button, .guest-button {
	width : 125pt;
	height: 25pt;
	padding: 0;
	margin: 2pt 0;
	box-sizing: border-box;
	background: black;
	color: white;
	border: 1pt solid gray;
}

.sign-up {
	width: 250pt;
	height: 25pt;
	padding: 0;
	margin: 2pt 0;
	box-sizing: border-box;
	background: black;
	color: white;
	border: 1pt solid gray;
	border-radius: 10pt;
}

.submit-button {
	border-radius: 10pt 0 0 10pt;
}

.guest-button {
	border-radius: 0 10pt 10pt 0;
}

.login {
	width : 250pt;
	height: 25pt;
	margin: 2pt 0;
	box-sizing: border-box;
	background: black;
	border: black;
	border-radius: 10pt;
	text-decoration: none;
	color: white;
	padding: 0 0 0 15pt;
	position: relative;
	z-index: 2;
}

.login::placeholder {
	color: gray;
	opacity: 0.8;
	position: relative;
	font-size: 12pt;
}

.login:focus {
	outline: none;
	border-color: #9ecaed;
    box-shadow: 0 0 10px #9ecaed;
}

.invalid:focus {
	border-color: red;
	box-shadow: 0 0 10px red;
}

.submit-button:hover, .guest-button:hover, .sign-up:hover {
	border-color: #9ecaed;
	box-shadow: 0 0 10px #9ecaed;
	cursor: pointer;
}

/* Logo */

.circle-container {
	display: flex;
	justify-content: center;
	align-content: center;
	flex-direction: column;
	width: 100%;
	position: fixed;
	height: 100%;
	top: 0;
	left: 0;
}

.outer-circle {
	position: relative;
	align-self: center;
	height: 350px;
	width: 350px;
	background: linear-gradient(#14ffe9, #ffeb3b, #ff00e0);
	border-radius: 50%;
	animation: rotate 1.5s linear infinite;
}

.outer-circle span {
	position: absolute;
	height: 350px;
	width: 350px;
	left: 0;
	background: linear-gradient(#14ffe9, #ffeb3b, #ff00e0);
	border-radius: 50%;
}

span:nth-child(1) {
  filter: blur(5px);
}

span:nth-child(2) {
  filter: blur(10px);
}

span:nth-child(3) {
  filter: blur(25px);
}

span:nth-child(4) {
  filter: blur(150px);
}

.inner-circle {
	height: 300px;
	width: 300px;
	position: absolute;
	background: black;
	top: 25px;
	left: 25px;
	border-radius: 50%;
	z-index: 2
}

@keyframes rotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

img {
	position: relative;
	width: 150px;
	top: 75px;
	
}

/* Mobile */
@media only screen and (max-height: 900px) {
	.circle-container {
		height: 80%;
	}

	form {
		top: 65vh;
	}

	.sign-up-container {
		top: 65vh;
	}
}

</style>